<template>
  <form
    autocomplete="off"
    @submit.prevent="handleSubmit"
  >
    <div>
      <div class="mb-4 input-field">
        <label for="password">New password</label>
        <input
          id="password"
          v-model="formData.password"
          v-focus
          class="input-field"
          type="password"
          name="password"
          :class="{ 'input-error': errors && 'password' in errors }"
        >

        <span
          v-if="errors && 'password' in errors"
          class="text-red-500"
        >
          {{ errors.password[0] }}
        </span>
      </div>

      <div class="mb-4 input-field">
        <label for="confirmPassword">Confirm password</label>
        <input
          id="confirmPassword"
          v-model="formData.confirmPassword"
          type="password"
          class="input-field"
        >
      </div>

      <AppButton
        class="bg-primary text-white"
        :disabled="!canSubmit"
        :processing="isSubmitting"
      >
        {{ isSubmitting ? 'Resetting password..' : 'Reset password' }}
      </AppButton>

      <RouterLink
        class="btn"
        :to="{ name: 'app_auth_login' }"
      >
        <i class="fa-regular fa-chevron-left fa-fw" /> Back to login
      </RouterLink>
    </div>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppButton } from '@/components/buttons';

import { useHttp } from '@/composables';

const emit = defineEmits(['password-reset']);

const route = useRoute();

const formData = reactive({
  password: import.meta.env.DEV ? 'admin123' : null,
  confirmPassword: import.meta.env.DEV ? 'admin123' : null,
});
const isSubmitting = ref(false);
const errors = ref(null);
const canSubmit = computed(() => !isSubmitting.value && formData.confirmPassword === formData.password);

const handleSubmit = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post(
    '/auth/password-reset',
    { token: route.query.token, password: formData.password },
  );

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('password-reset');
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};
</script>
